import RatiosContainer from "../../../Components/BonusUi/Ratios/RatiosContainer";

const Ratios = () => {
  return <RatiosContainer />;
};

export default Ratios;
